"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flagConfig = void 0;
exports.flagConfig = {
    benchmark_reports: {
        hasBenchmarkReportsFeatureFlag: true,
        shouldRedirectIndexEntryPointToBenchmarkReports: true,
        showBenchmarkReportsMenuItemFeatureFlag: true,
    },
    compliance_tab: {
        hasComplianceFeatureFlag: true,
        showComplianceTab: true,
    },
    deactivate: {
        canSelectOfferRows: true,
        canSelectSubAccountRows: true,
        canUseWithActivateDeactivate: true,
        hasDeactivateFeatureFlag: true,
        showAccountActivateDeactivateCard: true,
        showActivateDeactivateIndicator: true,
        showChangeOfferStatusButton: true,
        showChangeSubAccountStatusButton: true,
        showSelfServiceUserDetailsActivateDeactivateIndicator: true,
        showSubAccountActivateDeactivateCard: true,
        showUserActivateDeactivateCard: true,
        showUserDetailsActivateDeactivateIndicator: true,
        showWithActivateDeactivateStatusAction: true,
    },
    demand_cc_mvp: {
        hasDemandCCMVPFeatureFlag: true,
        shouldRedirectIndexEntryPointToHomePage: true,
        showBenchmarkReportsCard: true,
        showContractsCardFeatureFlag: true,
        showDemandUserSideNavFeatureFlag: true,
        showDemandUsersPageFeatureFlag: true,
        showExternalUserSideNavFeatureFlag: true,
        showMCIReportsCard: true,
        showPerformanceReportCard: true,
    },
    demand_filtering_tab: {
        showDemandFilteringTab: true,
    },
    demand_homepage: {
        hasDemandHomepageFeatureFlag: true,
        shouldRedirectIndexEntryPointToHomePage: true,
        showHomeMenuItemFeatureFlag: true,
    },
    demand_mvp: {
        hasDemandMVPFeatureFlag: true,
    },
    demand_partners_tab: {
        showDemandPartnersTab: true,
    },
    dev_tools: {
        hasDevToolsFeatureFlag: true,
    },
    draft_offer_integration: {
        hasDraftOfferIntegrationFeatureFlag: true,
    },
    enable_for_static_offers: {
        hasEnableForStaticOffersFeatureFlag: true,
    },
    enable_offer_ranking: {
        hasEnableOfferRankingFeatureFlag: true,
    },
    ghost_enablements_enabled: {
        hasGhostEnablementsEnabledFeatureFlag: true,
    },
    guide_homepage: {
        hasGuideHomepageFeatureFlag: true,
        showHomepageGuide: true,
    },
    guide_integrations: {
        hasGuideIntegrationsFeatureFlag: true,
        showIntegrationsGuideLink: true,
    },
    guide_performance_summary: {
        hasGuidePerformanceSummaryFlag: true,
        showPerformanceSummaryGuideLink: true,
    },
    guide_users: {
        hasGuideUsersFeatureFlag: true,
        showUsersGuideLink: true,
    },
    has_enabled_trans_union_attributes: {
        hasEnabledTransUnionAttributesFeatureFlag: true,
    },
    is_communication_eligibilities_updates_enabled: {
        isCommunicationEligibilitiesUpdatesEnabled: true,
    },
    is_draft_offers_enabled: {
        isDraftOffersEnabled: true,
    },
    is_offer_catalog_pro_mode_enabled: {
        isOfferCatalogProModeEnabled: true,
    },
    mci_reports: {
        hasMCIReportsFeatureFlag: true,
        shouldRedirectIndexEntryPointToMciReports: true,
        showMCIReportsMenuItemFeatureFlag: true,
    },
    new_reporting_infrastructure: {
        hasNewReportingInfrastructureEnabled: true,
    },
    notifications: {
        hasNotificationsFeatureFlag: true,
        showNotificationsHeaderItemFeatureFlag: true,
    },
    onboarding: {
        hasOnboardingFeatureFlag: true,
        showHelpCenterHeaderItemFeatureFlag: true,
        showSelfServiceUserSideNavFeatureFlag: true,
    },
    onboarding_tracking: {
        hasOnboardingTrackingFeatureFlag: true,
        showOnboardingTrackingTab: true,
    },
    product_type_schema: {
        hasUpdateProductTypeSchemaFeatureFlag: true,
    },
};
